import * as React from "react";
import { FC } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export const UploadIcon: FC<{ className?: string }> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path d="M22,13a1,1,0,0,0-1,1v4.213A2.79,2.79,0,0,1,18.213,21H5.787A2.79,2.79,0,0,1,3,18.213V14a1,1,0,0,0-2,0v4.213A4.792,4.792,0,0,0,5.787,23H18.213A4.792,4.792,0,0,0,23,18.213V14A1,1,0,0,0,22,13Z" />
            <path d="M6.707,8.707,11,4.414V17a1,1,0,0,0,2,0V4.414l4.293,4.293a1,1,0,0,0,1.414-1.414l-6-6a1,1,0,0,0-1.414,0l-6,6A1,1,0,0,0,6.707,8.707Z" />
        </SvgIcon>
    );
};

export default UploadIcon;
